<template>
    <span v-if="ov" class="j-sensitive-wrap">
        {{ eyeStyle === 'close' ? nv : ov }}
        <i v-if="eye && ov" :class="`j-sensitive-eye-${eyeStyle}`" @click="eyeChange" />
    </span>
</template>

<script>
import Encrypt from "@/utils/encrypt/encrypt";
export default {
  name: 'JSensitive',
  props: {
    encrypt: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    rule: { // 第一位为正数表示正向保留多少位， 第二位为负数表示倒向保留多少位
      type: Array,
      default: () => [1]
    },
    type: { // [id, phone, name]
      type: String,
      default: ''
    },
    switch: { // 脱敏状态绑定值 (true: 默认开启脱敏， false: 默认关闭脱敏)
      type: Boolean,
      default: false
    },
    eye: { // 关闭、开启脱敏开关
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      eyeStyle: 'close',
      nv: '',
      ov: ''
    }
  },
  watch: {
    switch: {
      handler (nv) {
        if (nv) {
          this.eyeStyle = 'open'
        } else {
          this.eyeStyle = 'close'
        }
      },
      immediate: true
    },
    value (nv) {
      this.handleOldValue(nv)
      this.updateSensitive()
    }
  },
  created () {
    this.handleOldValue(this.value)
    this.updateSensitive()
  },
  methods: {
    handleOldValue (value) {
        this.ov = String(value)
        // 解密脱敏
        if (this.encrypt) {
            const result = Encrypt.decryptString(this.encrypt)
            result && (this.ov = result)
        }
    },
    eyeChange () {
      if (this.eyeStyle === 'close') this.eyeStyle = 'open'
      else if (this.eyeStyle === 'open') this.eyeStyle = 'close'
    },
    updateSensitive () {
      // 解密脱敏格式字段来源于后端，直接赋值使用
      if (this.encrypt) return this.nv = this.value
      // 姓名 [1] 张**
      if (this.type === 'name') return this.handleSensitive([1])
      // 手机号 [3, -2] 131******91
      if (this.type === 'phone') return this.handleSensitive([3, -2])
      // 身份证号 [1, -1] 2**************7
      if (this.type === 'id') return this.handleSensitive([1, -1])
      this.handleSensitive(this.rule)
    },
    handleSensitive (rule) {
      let start = this.ov.substr(0, rule[0])
      let end = this.ov.substr(rule[1] || this.ov.length)
      let center = this.ov.substring(rule[0], this.ov.length + (rule[1] || 0))
      this.nv = `${start}${'*'.repeat(center.length)}${end}`
    }
  }
}
</script>

<style scoped lang="scss">
    .j-sensitive-wrap {
        display: inline-flex;
        align-items: center;
        i {
            display: inline-block;
            width: 16px;
            height: 16px;
            background-size: contain;
            background-repeat: no-repeat;
            margin: 0 5px;
            cursor: pointer;
        }
        .j-sensitive-eye-open {
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEeUlEQVRYR+1WXWwUZRQ995vZLZVQtFXUyAOipgaNIYaoECFSlEQT/7XgCyQV2angg1TYWdyFcXdxfyCtoSTdoTQNaJQU44MIBBMaeNEEjRH1QQX6ABpFbWsopGy7M8fsYqXdznarL8SEeZu59zv3fOf+zBVc5UeucnxcI/D/UmBLi33rpUt4kmCdCO8jMQMiVSD6RPArgeMC1a1Nu/4Ta039hcnU16QUCKc6aoXDG0EsJ+gvBywif4qgfcrUytTGtSt7J/KfkEBXV5f2bU//esK1QFRAxBFgPyiHNF37zF/p+2VozYp+f2tnzeBQbhaHuQjCp0AuygcVwW9CtTYaCuwrRaIkAauzc4pzLruX5NMFMIVdiir2lhk4U04BK23f77hMknws76ugtkRDgbDXOU8Ctm37furnYZKLAfQqJcuiQeNIucDF9kgq8ypcthJQSlRL1AysK/bxJBBJ2K2EuxaQn3WfPGq9Efj+3wYf8Y8k7NWEa19OiayMmcae0VjjCGxK7nzcpXMQgqwu8rAVNL4sFdxKtM3KKZmnu1ofqqYfL1X54YTdBLjbIBic4quoDTc1nB3BHEPAIlUumTkB4F4RaYqZRrNXcKury++c7muhoBFkAaNQcFANUTNwwOtMJNn2AYnlIrInZhorPQlsSrQ96wIfQeS0Prt6jlVfP1QCbAuJjePzKZeofHPjwZd/KLZZqfaZOeZOCeFTom4fKeYxCkSSmX0kXxClXo8FA+94Bc+35jc9vQMgKr2rWu2IhQKvednCicz7AF8CxIyHjFRBuRFHkhJJ2QMgp+qouMMKNfR4gqQzd8HhjyWLUuRo3DTy3TPu2ZTOLHMd7hXgWCzU+MgYAvmXcLLtCIg6pbQV0eDqd71Ampu7KvuzvecJ6J4kRDrjptHgmbq/u0tBUtGQYY4jEEnYqwi3XSCfx0LGglK3vCJlkYcIdbLOCjUeLT6bTNrTL4I9JKtFZG7MNPLFPnYf2Lp1z9TzzsVTJG6BkhfjQeNDLxJv79hdMzgwuJ/g/FHVnIPgzZjZmPaUP5FJumAQgu642bjEswvyH68MDjkHDQvjG4yTXoCFlk3bzygXD7iQXl3XDlnrV33nKX26fSGcXDdFNF3JPGtD4KuSBC7PAvsQwKUickZBFk5m/pdMV6qjFu7wMYA3iyAZMxtDo309R7HVvKvayQ5/QWC2iJys8PmXjJ5eJTugyBDZmpkPBx+TvFEEh7Wg8YQl4pYlkHeIN7fdls3KpwTnCHBeBBvUg3d3WIsX58oRSKU6pl1gLkywCaQmIvtv8FcvW7eufrD47IT7QEGJoZydH06FihU5Q+FOXbQDm9e/ckJEOAK4ffvBij8Gzy4gC/tAA4Gq/P6giG3qodpwKeKT3IgyzwkRJXnPleKRIQrOgrwISA0EM0D6/rmhoFsXCU70MxvXhuWk3Zy2l7oOnwdYR+DOoly6FPlagG4A7430eTnMSSng2Ya2fZ0+oN2UzTlVFX63Lzez5vdSP6+JSPxnAuVuNln7NQLXFPgLwOHnMKOCyh0AAAAASUVORK5CYII=");
        }
        .j-sensitive-eye-close {
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEcklEQVRYR+1WXWhbZRh+nnPSpMNNndWJ0Iuiwi6cMqQXU/xZK0OdFB3OKgji6racgAzW2vZEk3DsSU1SxgrWmaSllrGiI5u7cNUx0bIhiKDOfxBl/s5tMuyG7dbaJt8rpzMjTU+TbBfuZrkL33nf5/ne93ne7yUu84+XGR9XCPxvFbASA6uszk2fFLf8ogh096ZvmppCk0AaSblDBMsILhHICYLHhPgBmrbPU3ft+1Zz83QeLJxIGSJ4nZCEbQaChSQqIhBKDC6nzLwIwVMC8ZYTLoFP9Vtq7nFI5MEhQo3c0mUafRUTyGQy+jc/nW4XKAsCH8gcgf0QHtA9+sfQcRxbnzuDbbuuhzpbl1XavaTc7fPKllBr4I9y4A6RBStgDQ1V5/78Z7eIPApSALxRXeV9OdTW8nu5CjjnheAgD0VNo8EtzpVAOp2uOnZaDopIA4EJHfo6K7j5g0qAXcBnIFJFcrttGm0ViTAcS/cJ1PMEz0HX1todmw9XCh6JJ/0KTOZ7LtBOCdSbs/81tnR1GkMlNRCJ9z+sJPcewSkdWlOpm1uxZF0Onho7uOnz4psXCi4cT3aIIAHyrE/Xbw+3b/o5T2JOCywRLRtPfQVgBcl22zS2ud3cymS8uaNjvSDW+LzSUIngwvHkXhE8DmBXNBh4xpVAJJZcp4B9JH+sXcrb/H7/jBuBcDzZDUGzz4fV88ChdXcF/aHiOKunf2U2l/uCgPJ6PLfmqzCnAuF4ao+IrCfZZpvGdjdwx5pfH/3rSLUPa4vBZ78nB6OmsdEtNhRLHQDkIVIL2qY/PseGIsJwIj0Okauqq6rqQi9s/NUtySuv7axR0+eqXcHP+/ojOxi4zy02Eks/oaAyBA7bwcDqeXMgHE+NiMgjGrG5ywwMlFL+HJ/PkTWHoqbR4tq6/9ylgYmuoGHOIxCJp5qUyDskv7NNY8VCBEqAi0ek0QoGDhXHJhKDS8bVtFPVpSRX2qbhiH3uJDw/esd+EZFaDVpzV9C/pzjRQuAEsiBess1Aj2v5E6kepaQdxGjUDDzg6oJZL8f6WwS5QZJnvLp+Z6FnC8EdoVLDCVGoF+FJj0c/YLVv/NYVPN7/oILaD8Dj0VhvdfiPLEjAOQjFUsOAPE3ibdsMrC81ZMpNSCs20JhldgSCRSTiFT3H1o7M4tz42G6fV/yVDJkFtdLTf78o9a7jLBIH9U5jrUWqkqO4TM9bo8FAb9lb78gsVhNjEVGyVQAPgZGlvprm1tbmyeLYkgtJseBIHKdwp6ZrGdxQ9b21YcNUPqHzfOPk1CpFPqaAZyFyjbM/aIJt2qrlIauhIetGfEECRe95HwX1ArmrQDwK5G8i8jfJ6wS40Xl2L4AQox6y0+o0PitVMVcCkZ7Uk0rhreI1anaeKzEoao0ANxf1Ugn5JYFRAMN5n5drlysBZ9xOTkx+SGCweIe7UPJXh69GdmpZbjq3yOdVY9namlOFi2g54JI2dA6dJ/dSElYKXJbAxSa61O8rWssvNXklcVcI/AuSeVc/d9/P0QAAAABJRU5ErkJggg==");
        }
    }
</style>
